/**
  * Get the params of the url and Parse them into JSON
  * @param {string[]} - allowed params in url
  * @return {Object} params - Return the JSON object of the params
*/
export const extractParameters = queryString => {
    // Strip the `?` from the querystring
    const query = queryString.substr(1);

    // handle empty strings
    if (!query) {
        return {};
    }
    // extract from the queryString
    const parameters = query
        .split("&")
        .map((part) => {
            const [ key, value] = part.split("=");
            return [ decodeURIComponent(key), value === undefined ? true : decodeURIComponent(value) ];
        })
        .reduce((acc, [key, value]) => {

            // check the fields case : if there is two same parameters, put it in an Array
            if(key in acc){
                acc[key] instanceof Array ? acc[key].push(value) : acc[key] = [acc[key], value];
            } else {
                acc[key] = value;
            }
            return acc;
        }, {});

    /* For each key
     * recursively set in the object tree the values
     * [['a__b__c', 'foo']]  => { a: { b: { c: 'foo' } } }
     */
    return Object
        .entries(parameters)
        .map(([name, value]) => [name.split("__"), value])
        .reduce((params, [keys, value]) => {
            // for all the keys before the last, ensure empty objects
            const holder = keys.slice(0, -1).reduce((acc, key) => {
                // ensure an object is present for the key
                acc[key] = acc[key] || {};
                return acc[key];
            }, params);
            // get the last key of the array
            const lastKey = keys[keys.length - 1];
            // set the key in the holder
            holder[lastKey] = value;
            return params;
        }, {});
};
